import script from "./SupersetDesigner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupersetDesigner.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__